import { render } from "./TagCreator.vue?vue&type=template&id=58bda90a&scoped=true&ts=true"
import script from "./TagCreator.vue?vue&type=script&lang=ts"
export * from "./TagCreator.vue?vue&type=script&lang=ts"

import "./TagCreator.vue?vue&type=style&index=0&id=58bda90a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bda90a"]])

export default __exports__